export default __webpack_public_path__ + "static/media/15.27586b14.png";